import { typedWindow } from '../Window';

class HotJar {
  identify(userId: string | null) {
    if (typedWindow.hj) {
      typedWindow.hj('identify', userId, {});
    }
  }

  tagRecording(tags: string[]) {
    if (typedWindow.hj) {
      typedWindow.hj('tagRecording', tags);
    }
  }

  /**
   * Sends an event to Hotjar so it appears as a marker on session replay
   * timelines. Hotjar rejects event names containing anything other than
   * alphanumerics, dashes, and underscores, so invalid characters are
   * collapsed into underscores (e.g. "Checkout Started" -> "Checkout_Started").
   */
  event(name: string) {
    if (typedWindow.hj) {
      typedWindow.hj('event', name.replace(/[^a-zA-Z0-9_-]+/g, '_'));
    }
  }
}

const hotjar = new HotJar();
export default hotjar;
